import { queryOptions } from "@tanstack/react-query";
import {
  getAutomation,
  listAutomationRuns,
  listAutomations,
  listQuestionnaires,
  listWorkflows,
} from "api-client";

export const AUTOMATION_RUNS_PAGE_SIZE = 20;

export const automationKeys = {
  all: ["automations"] as const,
  lists: () => {
    return [...automationKeys.all, "list"] as const;
  },
  list: (productId: string | null) => {
    return [...automationKeys.lists(), productId] as const;
  },
  detail: (automationId: string) => {
    return [...automationKeys.all, "detail", automationId] as const;
  },
  runs: (automationId: string, pageIndex: number, pageSize: number) => {
    return [
      ...automationKeys.all,
      "runs",
      automationId,
      pageIndex,
      pageSize,
    ] as const;
  },
};

export function automationsQueryOptions(productId: string | null) {
  return queryOptions({
    queryKey: automationKeys.list(productId),
    queryFn: () => {
      return listAutomations({
        query: { productId: productId ?? undefined },
      }).then((res) => {
        return res.data.data;
      });
    },
  });
}

export function automationQueryOptions(automationId: string) {
  return queryOptions({
    queryKey: automationKeys.detail(automationId),
    queryFn: () => {
      return getAutomation({ path: { automationId } }).then((res) => {
        return res.data.data;
      });
    },
  });
}

export function automationRunsQueryOptions(
  automationId: string,
  pageIndex: number,
  pageSize: number,
) {
  return queryOptions({
    queryKey: automationKeys.runs(automationId, pageIndex, pageSize),
    queryFn: () => {
      return listAutomationRuns({
        path: { automationId },
        query: { pageIndex, pageSize },
      }).then((res) => {
        return res.data.data;
      });
    },
  });
}

export function automationWorkflowOptionsQueryOptions() {
  return queryOptions({
    queryKey: [...automationKeys.all, "workflow-options"] as const,
    queryFn: () => {
      return listWorkflows({
        query: { pageIndex: 0, pageSize: 100, query: "" },
      }).then((res) => {
        return res.data.data.currentPage;
      });
    },
  });
}

export function automationQuestionnaireOptionsQueryOptions() {
  return queryOptions({
    queryKey: [...automationKeys.all, "questionnaire-options"] as const,
    queryFn: () => {
      return listQuestionnaires({
        query: { pageIndex: 0, pageSize: 100 },
      }).then((res) => {
        return res.data.data.currentPage;
      });
    },
  });
}
